import type { FaireProductEntity } from "../../entity_types/product";

export const atc_fs_6: FaireProductEntity = {
  token: "atc_fs_6",
  type: "product",
  name: "SPF 50 Invisible Mist Sunscreen",
  brandName: "Bask",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/7e00f2f68c55749568bcaf0ce818c167150272e5067249e89b7c84f18622c9b1.webp",
  priceDollars: 18,
  msrpDollars: 36,
  description: "ATC migration seed product",
  tags: ["beauty", "atc"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
